import { render } from "./ProsedurSinkronisasi.vue?vue&type=template&id=128abf40"
import script from "./ProsedurSinkronisasi.vue?vue&type=script&lang=js"
export * from "./ProsedurSinkronisasi.vue?vue&type=script&lang=js"

import "./ProsedurSinkronisasi.vue?vue&type=style&index=0&id=128abf40&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__